document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('prod-recs-container');
  const productDivs = document.querySelectorAll('#all-products-data .product-data');
  const maxProducts = 4;

  if (!productDivs.length) {
    container.innerHTML = '<p style="text-align:center;">No products available.</p>';
    return;
  }

  // Convert NodeList to array
  let products = Array.from(productDivs);

  // Shuffle array
  for (let i = products.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [products[i], products[j]] = [products[j], products[i]];
  }

  // Take top maxProducts
  products = products.slice(0, maxProducts);

  // Render products in a responsive grid
  const gridStyle = `
    display:grid;
    grid-template-columns:repeat(auto-fill, minmax(160px, 1fr));
    gap:16px;
    padding:8px;
  `;

  container.innerHTML = `<div style="${gridStyle}">` + products.map(p => {
    const title = p.dataset.title;
    const url = p.dataset.url;
    const img = p.dataset.img ? `<img src="${p.dataset.img}" alt="${title}" style="border-radius:8px;display:block;margin:0 auto 8px;width:100%;height:auto;">` : '';
    const price = p.dataset.price ? `<div style="font-weight:600;">${p.dataset.price}</div>` : '';
    return `
      <div class="recommended-product-item" style="text-align:center;">
        <a href="${url}" style="text-decoration:none;color:inherit;">
          ${img}
          <div style="font-size:14px;">${title}</div>
          ${price}
        </a>
      </div>
    `;
  }).join('') + `</div>`;
});

